export default __webpack_public_path__ + "static/media/certificate4.dff7e05a.svg";